module.exports = {
  test: {
    title: '该页面在实际开发可以删除，本例用于使用vuex管理页面状态的演示',
    currentcode: '当前编码',
    precode: '之前编码',
    changecode: '改编编码',
    simplealert: '简单弹框',
    alerttitle: '弹框标题',
    ok: '确认',
    close: '关闭',
    welcome: '欢迎使用VBP'
  }
}



// WEBPACK FOOTER //
// ./src/languages/zh.js